import Router from 'vue-router';
import Vue from 'vue';
import store from './store';

Vue.use(Router);

import Login from './views/Login';
import Home from './views/Home';
import ProductType from './views/product_type/ProductTypeList';
import Supplier from './views/supplier/SupplierList';
import Product from './views/product/ProductList';
import Customer from './views/customer/CustomerList';
import RawMaterial from './views/raw_material/RawMaterialList';
import Sale from './views/sale/SaleList';
import JobOrder from './views/job_order/JobOrderList';
import Report from './views/report/Main';
import Set from './views/set/SetList';
import User from './views/user/UserList';

const Foo = { template: '<div>ederley</div>' };

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        layout: 'simple-layout'
      }
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/report',
      name: 'Report',
      component: Report,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/producttype',
      name: 'Product Type Index',
      component: ProductType,
      meta: {
        requiresAuth: true
      },
      props: {
        create: false,
        show: false,
        edit: false
      }
    },
    {
      path: '/producttype/create',
      name: 'Product Type Create',
      component: ProductType,
      meta: {
        requiresAuth: true
      },
      props: {
        create: true,
        show: false,
        edit: false
      }
    },
    {
      path: '/producttype/:id?',
      name: 'Product Type Show',
      component: ProductType,
      meta: {
        requiresAuth: true
      },
      props: {
        show: true,
        create: false,
        edit: false
      }
    },
    {
      path: '/producttype/:id?/edit',
      name: 'Product Type Edit',
      component: ProductType,
      meta: {
        requiresAuth: true
      },
      props: {
        show: false,
        create: false,
        edit: true
      }
    },
    {
      path: '/sale',
      name: 'Sale Index',
      component: Sale,
      meta: {
        requiresAuth: true
      },
      props: {
        create: false,
        show: false,
        edit: false
      }
    },
    {
      path: '/sale/:id?',
      name: 'Sale Show',
      component: Sale,
      meta: {
        requiresAuth: true
      },
      props: {
        create: false,
        show: true,
        edit: false
      }
    },
    {
      path: '/supplier',
      name: 'Supplier Index',
      component: Supplier,
      meta: {
        requiresAuth: true
      },
      props: {
        create: false,
        show: false,
        edit: false
      }
    },
    {
      path: '/supplier/create',
      name: 'Supplier Create',
      component: Supplier,
      meta: {
        requiresAuth: true
      },
      props: {
        create: true,
        show: false,
        edit: false
      }
    },
    {
      path: '/supplier/:id?',
      name: 'Supplier Show',
      component: Supplier,
      meta: {
        requiresAuth: true
      },
      props: {
        show: true,
        create: false,
        edit: false
      }
    },
    {
      path: '/supplier/:id?/edit',
      name: 'Supplier Edit',
      component: Supplier,
      meta: {
        requiresAuth: true
      },
      props: {
        show: false,
        create: false,
        edit: true
      }
    },
    {
      path: '/set',
      name: 'Set Index',
      component: Set,
      meta: {
        requiresAuth: true
      },
      props: {
        create: false,
        show: false,
        edit: false
      }
    },
    {
      path: '/set/create',
      name: 'Set Create',
      component: Set,
      meta: {
        requiresAuth: true
      },
      props: {
        create: true,
        show: false,
        edit: false
      }
    },
    {
      path: '/set/:id?',
      name: 'Set Show',
      component: Set,
      meta: {
        requiresAuth: true
      },
      props: {
        show: true,
        create: false,
        edit: false
      }
    },
    {
      path: '/product',
      name: 'Product Index',
      component: Product,
      meta: {
        requiresAuth: true
      },
      props: {
        create: false,
        show: false,
        edit: false
      }
    },
    {
      path: '/product/create',
      name: 'Product Create',
      component: Product,
      meta: {
        requiresAuth: true
      },
      props: {
        create: true,
        show: false,
        edit: false
      }
    },
    {
      path: '/product/:id?',
      name: 'Product Show',
      component: Product,
      meta: {
        requiresAuth: true
      },
      props: {
        show: true,
        create: false,
        edit: false
      }
    },
    {
      path: '/product/:id?/edit',
      name: 'Product Edit',
      component: Product,
      meta: {
        requiresAuth: true
      },
      props: {
        show: false,
        create: false,
        edit: true
      }
    },
    {
      path: '/customer',
      name: 'Customer Index',
      component: Customer,
      meta: {
        requiresAuth: true
      },
      props: {
        create: false,
        show: false
      }
    },
    {
      path: '/customer/create',
      name: 'Customer Create',
      component: Customer,
      meta: {
        requiresAuth: true
      },
      props: {
        create: true,
        show: false
      }
    },
    {
      path: '/customer/:id?',
      name: 'Customer Show',
      component: Customer,
      meta: {
        requiresAuth: true
      },
      props: {
        show: true,
        create: false
      }
    },
    {
      path: '/customer/:id?/edit',
      name: 'Customer Edit',
      component: Customer,
      meta: {
        requiresAuth: true
      },
      props: {
        show: false,
        create: false,
        edit: true
      }
    },
    {
      path: '/user',
      name: 'User Index',
      component: User,
      meta: {
        requiresAuth: true
      },
      props: {
        create: false,
        show: false
      }
    },
    {
      path: '/user/create',
      name: 'User Create',
      component: User,
      meta: {
        requiresAuth: true
      },
      props: {
        create: true,
        show: false
      }
    },
    {
      path: '/user/:id?',
      name: 'User Show',
      component: User,
      meta: {
        requiresAuth: true
      },
      props: {
        show: true,
        create: false
      }
    },
    {
      path: '/user/:id?/edit',
      name: 'User Edit',
      component: User,
      meta: {
        requiresAuth: true
      },
      props: {
        show: false,
        create: false,
        edit: true
      }
    },
    {
      path: '/rawmaterial',
      name: 'RawMaterial Index',
      component: RawMaterial,
      meta: {
        requiresAuth: true
      },
      props: {
        create: false,
        show: false
      }
    },
    {
      path: '/rawmaterial/create',
      name: 'RawMaterial Create',
      component: RawMaterial,
      meta: {
        requiresAuth: true
      },
      props: {
        create: true,
        show: false
      }
    },
    {
      path: '/rawmaterial/:id?',
      name: 'RawMaterial Show',
      component: RawMaterial,
      meta: {
        requiresAuth: true
      },
      props: {
        show: true,
        create: false
      }
    },
    {
      path: '/rawmaterial/:id?/edit',
      name: 'RawMaterial Edit',
      component: RawMaterial,
      meta: {
        requiresAuth: true
      },
      props: {
        show: false,
        create: false,
        edit: true,
        inventory: false
      }
    },
    {
      path: '/rawmaterial/:id?/inventory',
      name: 'RawMaterial Inventory',
      component: RawMaterial,
      meta: {
        requiresAuth: true
      },
      props: {
        show: false,
        create: false,
        edit: false,
        inventory: true
      }
    },
    {
      path: '/joborder',
      name: 'Job Order Index',
      component: JobOrder,
      meta: {
        requiresAuth: true
      },
      props: {
        create: false,
        show: false,
        edit: false
      }
    },
    {
      path: '/joborder/create',
      name: 'Job Order Create',
      component: JobOrder,
      meta: {
        requiresAuth: true
      },
      props: {
        create: true,
        show: false,
        edit: false
      }
    },
    {
      path: '/joborder/:id?',
      name: 'Job Order Show',
      component: JobOrder,
      meta: {
        requiresAuth: true
      },
      props: {
        show: true,
        create: false,
        edit: false
      }
    },
    {
      path: '/joborder/:id?/edit',
      name: 'JobOrder Edit',
      component: JobOrder,
      meta: {
        requiresAuth: true
      },
      props: {
        show: false,
        create: false,
        edit: true
      }
    },
    {
      path: '/foo',
      name: 'Foo',
      component: Foo,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  store.commit('SET_LAYOUT', to.meta.layout || 'app-layout');
  store.dispatch('clearDashboardRefresh');
  store.commit('SET_LAST_ACTION', new Date().getTime() / 1000);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next({ name: 'Login' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
